/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CompetitorRegularAi from './competitor-regular-ai-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CompetitorRegularAi {...validProps} />;
}
SvgComponent.iconName = 'competitorRegularAi';

export const CompetitorRegularAiIcon = svgIconWrapper(SvgComponent);
